<template>
  <form @submit.stop.prevent="moveStock">
    <div class="my-3">
      <label>Product</label>
      <input
          v-model="stock.productName"
          readonly disabled
          class="form-control"
      />
    </div>
    <div class="my-3">
      <label>Prev Warehouse</label>
      <input
          v-model="stock.warehouseName"
          readonly disabled
          class="form-control"
      />
    </div>
    <div class="my-5">
      <label>Shipment</label>
      <multiselect v-model="stock.shipmentId" :options="stock.shipments" :class="{
                        'is-invalid': v$.stock.shipmentId.$error,
                  }" class="multiselect-height-3" placeholder="Select one" :custom-label="customLabel" track-by="orderId">
      </multiselect>
      <p
          v-for="error in v$.stock.shipmentId.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="my-3">
      <label>New Warehouse</label>
      <multiselect v-model="stock.new_warehouse" :options="warehouses.objects"
                   :class="{
                        'is-invalid': v$.stock.new_warehouse.$error,
                  }"
                   placeholder="Select one" label="name" track-by="name"></multiselect>
      <p
          v-for="error of v$.stock.new_warehouse.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="my-3">
      <label>Quantity</label>
      <input
          v-model="stock.quantity"
          name="name"
          type="number"
          class="form-control"
          :class="{
            'is-invalid': v$.stock.quantity.$error,
          }"
      />
      <p
          v-for="error of v$.stock.quantity.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in stockErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="lg" class="py-2 text-white" disabled v-if="stockLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-2 text-white" type="submit" v-else>Move Stock</b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import Multiselect from "vue-multiselect";
import {mapGetters} from "vuex";

export default {
name: "move-stock-modal",
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    Multiselect
  },
  data() {
    return {
      stock: this.stockInfo,
    }
  },
  props: {
    stockInfo: {
      type: Object,
      default(){
        return {
          productId: '',
          productName: '',
          shipments: [],
          warehouseId: '',
          warehouseName: '',
          shipmentId: '',
          quantity: '',
          dateOrdered: '',
          description: ''
        }
      }
    },
    warehouses: {
      type: Object
    }
  },
  validations () {
    return {
      stock: {
        quantity: {required},
        shipmentId: {required},
        new_warehouse: {required}
      }
    }
  },
  computed: {
    ... mapGetters({
      stockLoading: 'stock/stockLoading',
      stockErrors: 'stock/stockErrors'
    }),
  },
  methods: {
    async moveStock() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        shipmentId: this.stock.shipmentId.publicId,
        quantity: parseInt(this.stock.quantity),
        targetWarehouseId: this.stock.new_warehouse.publicId
      }
      this.$emit('moveStock', data)
      this.v$.$touch();
    },
    customLabel ({ orderId, warehouseId }) {
      return `${orderId} – ${warehouseId?.name}`
    }
  }
}
</script>

<style scoped>

</style>
